const O = Object

export const assign = O.assign
export const freeze = O.freeze
export const values = O.values
export const entries = O.entries
export const keys = O.keys
export const fromEntries = O.fromEntries
export const hasOwn = O.hasOwn
export const defineProperty = O.defineProperty